<template>
  <b-row class="todo">
    <b-row class="center">
      <h3>{{ postagem.title }}</h3>
    </b-row>

    <b-row>
      <b-col cols="7"
        ><img
          width="500px"
          :src="postagem.img"
        />
      </b-col>

      <b-col cols="4">
        <div>
          <span><b>Equipe: </b></span>
          <span>{{ postagem.equipe }}</span>
        </div>

        <div>
          <span><b>Contato: </b></span>
          <span><a :href="postagem.creditos" target="_blank">Página do Desenvolvedor</a></span>
        </div>

        <div>
          <span><b>Data de modificação: </b></span>
          <span>{{postagem.data}}</span>
        </div>

        <div>
            <b-button
            v-if="postagem.download"
            class="btn"
            :href="postagem.download"
            target="_blank"
            block
            variant="primary"
            >Download</b-button>

            <b-button
            v-else
            class="btn"
            href="#"
            block
            variant="danger"
            disabled
            >Link fora do ar</b-button>
        </div>
      </b-col>
    </b-row>

    <div class="edicao">
      <b-row><h3>Edição</h3></b-row>
      <b-row>
        <b-form @submit="onSubmit">
          <b-form-group id="input-group-1" label="Título:" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="postagem.title"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group id="input-group-1" label="URL da Imagem:" label-for="input-2">
            <b-form-input id="input-2" v-model="postagem.img"></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-1"
            label="Contato da Equipe"
            label-for="input-3"
            description="Campo obrigatório"
          >
            <b-form-input
              id="input-3"
              v-model="postagem.creditos"
              type="text"
              required
              placeholder="Entre com o e-mail"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-1"
            label="Link para Download"
            label-for="input-5"

          >
            <b-form-input
              id="input-5"
              v-model="postagem.download"
              type="text"
              placeholder="Link para Download"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-1"
            label="Data da modificação"
            label-for="input-6"

          >
            <b-form-input
              id="input-6"
              v-model="postagem.data"
              type="date"
              placeholder="Data da modificação"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-3"
            label="Equipe de tradução:"
            label-for="input-4"
          >
            <b-form-select
              id="input-4"
              v-model="postagem.equipe"
              :options="equipes"
              required
            ></b-form-select>
          </b-form-group>
          <b-button type="submit" variant="dark">Editar</b-button>
        </b-form>
      </b-row>
    </div>
    
  </b-row>
</template>


<script>
export default {
  name: "DetalharPostagem",
  data() {
    return {
      //capturando a postagem completa de ListaDePostagens
      postagem: this.$route.params.postagem,
      equipes: [
        "Traduções PKG",
        "Zelda Tradução",
        "Team Xeno Traduções",
        "Mafra Team",
        "Heroes Of Time Brasil",
      ],
      data: new Date()
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      alert(`Postagem Editada com sucesso! \n
      Titulo: ${this.postagem.title}\n
      URL da Imagem: ${this.postagem.img}\n
      Creditos: ${this.postagem.creditos}\n
      URL do Download: ${this.postagem.download}\n
      Equipe: ${this.postagem.equipe}\n`
      );
    },
    created() {
      this.equipes.push(this.postagem.equipe);
    },
  },
};
</script>

<style scoped>

.todo {
  display: block;
  width: 100%;
  margin: 0 auto;
  padding: 10px;
  background-color: white;
  border-radius:  15px;
}

input.form-control{
  min-width: 500px;
}

.center{
  justify-content: center;
}

.edicao{
  padding-left: 20px;
  padding-top: 30px;
}
</style>